import classNames from "classnames";
import React, { useContext, useEffect, useState } from "react";
import { AuthContext, User } from "../auth";
import { Content } from "../globalType";

type HeaderProps = {
  goToPage: (page: string, content: Content | null) => void;
}

export function Header({goToPage}: HeaderProps) {
  const authContext = useContext(AuthContext);
  const [user, setUser] = useState<User | null | undefined>(null);
  const [isLoading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    setUser(authContext?.user);
  }, [authContext?.user]);

  useEffect(() => {
    setLoading(!!authContext?.isLoading);
  }, [authContext?.isLoading]);

  const thCls = classNames('pointer lang', {'active': authContext?.lang === 'th'})
  const enCls = classNames('pointer lang', {'active': authContext?.lang === 'en'}) 
  return (
    <>
      <header key="web" className="web">
        <div className="container H-container pt-2 pb-2">
          <div className="row align-items-center">
            <div className="col-2">
              <a href="/">
                <img src="/ondemand/static/img/logo.png" alt="logo" className="logo" />
              </a>
            </div>
            <div className="col-10 d-flex justify-content-end">

              <div className="ml-3 v-center">
                <p className="m-0 lang-BG">
                  <span onClick={() => {authContext?.setLang('th')}} className={thCls}>TH</span>
                  <span className="ml-2 mr-2">|</span>
                  <span onClick={() => {authContext?.setLang('en')}} className={enCls}>EN</span>
                </p>
              </div>
              {isLoading && (
                <div className="user-BG v-center pointer">
                  <img className="ml-2 mr-2" src="/ondemand/static/img/account.png" alt="" />
                  <h5>Loading</h5>
                </div>
              )}
              {!user && !isLoading && (
                <div onClick={authContext?.login} className="user-BG v-center pointer">
                  <img className="ml-2 mr-2" src="/ondemand/static/img/account.png" alt="" />
                  <h5>Login</h5>
                </div>
              )}
              {user && !isLoading && (
                <>
                  <div
                    id="userMenu"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <div className="infoUser-BG">
                      <img src={user.avatar} alt="userImg" />
                      <div>
                        {user.display_name}
                      </div>
                    </div>
                  </div>
                  <ul
                    className="dropdown-menu dropdown-menu-dark userMenu-BG"
                    aria-labelledby="userMenu"
                  >
                    <div className="d-flex">
                      <button
                        type="button"
                        className="btn-close xBT"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="userInfo">
                      <img src={user.avatar} alt="" />
                      <p className="pink-txt">สวัสดี, {user.display_name}</p>
                    </div>
                    <li>
                      <a className="dropdown-item" href="https://myaccount.trueid.net/th/me">
                        <img src="/ondemand/static/img/user_profile.png" alt="menu" />
                        ข้อมูลส่วนตัว
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item" href="https://home.trueid.net/mylibrary">
                        <img src="/ondemand/static/img/user_storage.png" alt="menu" />
                        คลังของฉัน
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item" href="https://myaccount.trueid.net/th/subscriptions">
                        <img src="/ondemand/static/img/user_menu.png" alt="menu" />
                        แพ็กเกจของฉัน
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item" onClick={authContext?.logout}>
                        <img src="/ondemand/static/img/user_logout.png" alt="menu" />
                        ออกจากระบบ
                      </a>
                    </li>
                  </ul>
                </>
              )}

              <div className="ml-4 watch-BG pink-BG pointer">
                <p className="m-0">
                  Watch Now
                  <img src="/ondemand/static/img/play-white.png" alt="" />
                </p>
              </div>
            </div>
          </div>
        </div>
      </header>
      <header key="mobile" className="mobile">
        <div>
          <div>
            <a href="/">
              <img src="/ondemand/static/img/logo.png" alt="logo" className="logo" />
            </a>
            
          </div>
          {isLoading && (
            <div className="user-BG v-center">
              <img className="ml-2 mr-2" src="/ondemand/static/img/account.png" alt="" />
              <h5>Loading</h5>
            </div>
          )}
          {!user && !isLoading && (
            <div onClick={authContext?.login} className="user-BG v-center">
              <img className="ml-2 mr-2" src="/ondemand/static/img/account.png" alt="" />
              <h5>Login</h5>
            </div>
          )}
          {user && !isLoading && (
            <>
              <div
                id="userMenu"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <div className="infoUser-BG">
                  <img src={user.avatar} alt="userImg" />
                </div>
              </div>
              <ul
                className="dropdown-menu dropdown-menu-dark userMenu-BG"
                aria-labelledby="userMenu"
              >
                <div className="d-flex">
                  <button
                    type="button"
                    className="btn-close xBT"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div className="userInfo">
                  <img src={user.avatar} alt="" />
                  <p className="pink-txt">สวัสดี, {user.display_name}</p>
                </div>
                <li>
                  <a className="dropdown-item" href="https://myaccount.trueid.net/th/me">
                    <img src="/ondemand/static/img/user_profile.png" alt="menu" />
                    ข้อมูลส่วนตัว
                  </a>
                </li>
                <li>
                  <a className="dropdown-item" href="https://home.trueid.net/mylibrary">
                    <img src="/ondemand/static/img/user_storage.png" alt="menu" />
                    คลังของฉัน
                  </a>
                </li>
                <li>
                  <a className="dropdown-item" href="https://myaccount.trueid.net/th/subscriptions">
                    <img src="/ondemand/static/img/user_menu.png" alt="menu" />
                    แพ็กเกจของฉัน
                  </a>
                </li>
                <li>
                  <a className="dropdown-item" onClick={authContext?.logout}>
                    <img src="/ondemand/static/img/user_logout.png" alt="menu" />
                    ออกจากระบบ
                  </a>
                </li>
              </ul>
            </>
          )}
        </div>
      </header>
    </>
  );
}
